import React from "react";
import { useLocation } from "react-router-dom";
import Navigation from "./Navigation";
import Breadcrumb from "../shared/Breadcrumb";
import AdminNavigation from './AdminNavigation';

const Header: React.FC = () => {
    const location = useLocation();
    const hideBreadcrumbs = location.pathname === '/signup' || location.pathname === '/login';
    const overlayHero = location.pathname === '/buy-outs';
    
    return (
        <>
            {/* Preloader */}
            {/* <div className="preloader-bg"></div>
      <div id="preloader">
        <div id="preloader-status">
          <div className="preloader-position loader"> <span></span> </div>
        </div>
      </div> */}

            {/* Progress scroll totop */}
            <div className="progress-wrap cursor-pointer">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </div>

            {/* Navbar */}
            <nav className={`navbar navbar-expand-lg${overlayHero ? ' ventus-overlay-navbar' : ''}`}>
                <div className="container">
                    {/* Logo */}
                    <div className="logo-wrapper">
                        <a className="logo" href="http://ventustravel.co.uk/">
                            <img src="/assets/img/logo.svg" className="logo-img" alt="Ventus Travel" />
                        </a>
                    </div>

                    <Navigation />
                </div>
            </nav>
            <AdminNavigation />
            {!hideBreadcrumbs && <Breadcrumb />}
        </>
    );
};

export default Header;
